/*
    © 2022 KondaSoft.com
    https://www.kondasoft.com
*/

// Cart count badges - Animate every 5 sec
setInterval(() => {
    document.querySelectorAll('.cart-count-badge').forEach((badge) => {
        badge.classList.add(badge.dataset.animateClass)

        setTimeout(() => {
            badge.classList.remove(badge.dataset.animateClass)
        }, 2000)
    })
}, 5000)

// Whatsapp button app - hide on oncanvas open
document.querySelectorAll('.offcanvas').forEach((offcanvas) => {
    offcanvas.addEventListener('show.bs.offcanvas', () => {
        const whatsappElem = document.querySelector('#rawa-container')
        if (whatsappElem) {
            whatsappElem.style.display = 'none'
        }
    })
})

document.querySelectorAll('.offcanvas').forEach((offcanvas) => {
    offcanvas.addEventListener('hide.bs.offcanvas', () => {
        const whatsappElem = document.querySelector('#rawa-container')
        if (whatsappElem) {
            whatsappElem.style.display = 'block'
        }
    })
})
